
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_109_2_Modal";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_109_2_Modal__root","childrenContainer":"wds_1_109_2_Modal__childrenContainer","closeButton":"wds_1_109_2_Modal__closeButton","modal":"wds_1_109_2_Modal__modal","navPrev":"wds_1_109_2_Modal__navPrev","navNext":"wds_1_109_2_Modal__navNext"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




